import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Apiurl, GetToken, RemoveUserSession } from "../Utils/utils";
import { useNavigate } from "react-router-dom";

const ProfileContext = createContext();

export const useProfile = () => {
  return useContext(ProfileContext);
};

export const ProfileProvider = ({ children }) => {
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);

  const navigate = useNavigate();
  const LoginToken = GetToken();

  const fetchProfile = useCallback(async () => {
    try {
      setLoadingProfile(true);

      const response = await axios.get(
        `${Apiurl()}/Profile/GetProfile`,
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
        }
      );

      const data = JSON.parse(response?.data?.data);
      setProfileData(data);
      setLoadingProfile(false);
    } catch (error) {
      setLoadingProfile(false);

      if (error?.response?.status === 401) {
        RemoveUserSession();
        navigate("/", { replace: true });;
      }
    }
  }, [LoginToken, navigate]);

  useEffect(() => {
    if (LoginToken) {
      fetchProfile();
    }
  }, [LoginToken, fetchProfile]);

  return (
    <ProfileContext.Provider
      value={{
        profileData,
        fetchProfile,
        loadingProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};